// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"9213d5d6","455":"c1c43742","977":"8c4d305a"}[chunkId] + ".chunk.js";
};